/**
 * Who can see and act on Bulk > Bulk Order > Shopify Orders (clensta.com
 * website orders → ShipShopy): admins (role 1) + this explicit allowlist only.
 *
 * Single frontend copy — imported by the menu (Bulk/index.js) and both pages
 * (ShopifyOrderList.js, ShopifyOrderDetails.js). The backend enforces the same
 * list on every /api/ai/shopify-orders/* call: SHOPIFY_ORDER_ACCESS_PHONES in
 * manijment-api services/ai-service/shopifyOrderOps.js — keep the two in sync.
 */
import { getDecryptDataFromLocal } from "../../utils/encrypt";

export const SHOPIFY_ORDER_ACCESS_PHONES = ["9891774071", "9811068834", "8800970879", "9315481432", "9354530453", "9719836187"];

// "Edit address" (buyer name/address) — ONLY these two logins, not admins and
// not the rest of the list above. Backend twin: SHOPIFY_ADDRESS_EDIT_PHONES in
// manijment-api services/ai-service/shopifyOrderOps.js (the real gate).
export const SHOPIFY_ADDRESS_EDIT_PHONES = ["9354530453", "9719836187"];

export const canEditShopifyAddresses = () =>
  SHOPIFY_ADDRESS_EDIT_PHONES.includes(String(getDecryptDataFromLocal("phoneNumber")));

export const canAccessShopifyOrders = () =>
  getDecryptDataFromLocal("setRole") == 1 || SHOPIFY_ORDER_ACCESS_PHONES.includes(String(getDecryptDataFromLocal("phoneNumber")));
